import React, {Component} from 'react'
import './SplahsBtn.css'


export default class SplahsBtn extends Component {
    render() {
        const {
            onClick,
            children} = this.props;

        return(
            <button type={this.props.type ? this.props.type : null} onClick={onClick} className="splash-btn">
                {children}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SplahsBtn.js